var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyCupSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 220.279,
    y: 306.605,
    style: {
      fill: "#F6E27D"
    },
    width: 71.442,
    height: 95.256
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 306.605,
    style: {
      fill: "#F5DC60"
    },
    width: 35.721,
    height: 95.256
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.837,
    y: 389.953,
    style: {
      fill: "#88888F"
    },
    width: 214.326,
    height: 119.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 389.953,
    style: {
      fill: "#797781"
    },
    width: 107.163,
    height: 119.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.372,
    y: 431.628,
    style: {
      fill: "#C6C5CA"
    },
    width: 95.256,
    height: 35.721
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8E99B"
    },
    d: "M0,2.977v17.86c0,40.177,2.371,91.681,20.862,133.705c10.105,22.967,24.237,40.929,42.001,53.386 c20.142,14.12,45.062,21.281,74.067,21.281h3.751C153.9,280.565,200.518,318.512,256,318.512s102.1-37.946,115.319-89.302h3.751 c29.005,0,53.926-7.161,74.067-21.281c17.764-12.457,31.895-30.419,42.001-53.386C509.629,112.519,512,61.014,512,20.837V2.977H0z  M35.955,38.698H136.93v154.791C69.582,193.488,38.892,146.954,35.955,38.698z M375.07,193.488V38.698h100.975 C473.108,146.954,442.417,193.488,375.07,193.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6E27D"
    },
    d: "M256,2.977v315.535c55.482,0,102.1-37.946,115.319-89.302h3.751c29.005,0,53.926-7.161,74.067-21.281 c17.764-12.457,31.895-30.419,42.001-53.386C509.629,112.519,512,61.014,512,20.837V2.977H256z M375.07,193.488V38.698h100.975 C473.108,146.954,442.417,193.488,375.07,193.488z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyCupSvgrepoCom);
export default __webpack_public_path__ + "static/media/trophy-cup-svgrepo-com.0a577f3ce63d8d4e2851e0e1b777b2d6.svg";
export { ForwardRef as ReactComponent };